export default __webpack_public_path__ + "static/media/fashion-body.638376df.png";